var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpecificPurpose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Specific Purposes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 3.83366C11.6087 3.83366 14.167 5.00033 14.167 8.12533C14.167 9.92532 12.7337 12.017 10.0003 14.2253C7.26699 12.017 5.83366 9.91699 5.83366 8.12533C5.83366 5.00033 8.39199 3.83366 10.0003 3.83366ZM10.0003 2.16699C7.27533 2.16699 4.16699 4.21699 4.16699 8.12533C4.16699 10.7253 6.10866 13.467 10.0003 16.3337C13.892 13.467 15.8337 10.7253 15.8337 8.12533C15.8337 4.21699 12.7253 2.16699 10.0003 2.16699Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 6.33366C9.08366 6.33366 8.33366 7.08366 8.33366 8.00033C8.33366 8.91699 9.08366 9.66699 10.0003 9.66699C10.4424 9.66699 10.8663 9.4914 11.1788 9.17884C11.4914 8.86628 11.667 8.44235 11.667 8.00033C11.667 7.5583 11.4914 7.13437 11.1788 6.82181C10.8663 6.50925 10.4424 6.33366 10.0003 6.33366ZM4.16699 17.167H15.8337V18.8337H4.16699V17.167Z",
    fill: "#333333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecificPurpose);
export default __webpack_public_path__ + "static/media/specific-purpose.4aa82fed58b008bc34c1d8dae68812bc.svg";
export { ForwardRef as ReactComponent };